import * as React from 'react';
import { H2 } from '@grandvisionhq/iris-ui';
import { ProductStockIndicator } from '../../StockIndicator/ProductStockIndicator.js';

const FacetPickerHeader = ({ children , enableStockIndicator ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "facet-picker-header"
    }, /*#__PURE__*/ React.createElement(H2, {
        className: "facet-picker-header__text",
        variant: "heading-smallest"
    }, children), enableStockIndicator && /*#__PURE__*/ React.createElement(ProductStockIndicator, null));
};

export { FacetPickerHeader };
//# sourceMappingURL=FacetPickerHeader.js.map
